export default "__VITE_ASSET__smGV6IYK__"